export const AwsConfigApiGateway = {
  pooledTenantApiUrl: process.env.REACT_APP_POOLED_TENANT_API_URL,
  pooledTenantApiKey: process.env.REACT_APP_POOLED_TENANT_API_KEY,
  adminApiUrl: process.env.REACT_APP_ADMIN_API_URL,
};
